import React from "react"
import "../styles/styles.scss"
import HomeIntro from "../components/HomeIntro"
import Evaluation from "../components/Evaluation"
import FullPowerProgram from "../components/FullPowerProgram"
import PowerProgram from "../components/PowerProgram"
import JoinCommunity from "../components/JoinCommunityRow"
import Layout from "../components/layout"
import PowerUpDown from "../components/PowerUpDown"
import Quote from "../components/Quote"
import SEO from "../components/seo"
import styles from "../styles/home.module.scss"
import { Helmet } from "react-helmet"

//Static Home Page

const IndexPage = ({ data }) => (
  <Layout>
    <Helmet>
       <title>Home | em•power with Shawna | Online Fitness Coach</title>
       <meta name="title" content="Home" />
            <meta name="description" content="Welcome to em•power with Shawna! This is your place for everything from fitness to meditation to health and wellness. Check out our Power Up and Power Down videos today." />   
             </Helmet>

    <HomeIntro />

    <Evaluation />

    <FullPowerProgram />

    <PowerProgram />

    <section className={styles.powerUpDown}>
      <PowerUpDown />
    </section>

    <Quote
      quote={"We are going to revolutionize the way you approach fitness, mindfulness, overcoming challenge, and achieving your life goals."}
      personName={"- shawna"}
    />

    <section className={styles.joinCommunity}>
      <JoinCommunity />
    </section>

  </Layout>
)

export default IndexPage

{
  /*
export const query = graphql`
  query {
    allWordpressWpMedia {
      edges {
        node {
          localFile {
            childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
 */
}